import React from 'react'

import { Info } from '@material-ui/icons'

import { SyncLogsButtonBase } from './SyncLogsButtonBase'

import { useApi } from '../../hooks/storeHook'

import { integrationTypeNames, StoreIntegrationType } from '../../types/integrationTypeUtils'

import { IntegrationType } from '../../server/mpsklad_core/Entity/IntegrationType'

export type SyncLogsTypeProps = {
  type: IntegrationType.MoySklad
  accountId?: undefined
} | {
  type: StoreIntegrationType
  accountId: number
}

export type SyncLogsExtraIdProps = {
  productId: number
  orderId?: undefined
} | {
  orderId: number
  productId?: undefined
}

export type SyncLogsButtonProps =
  SyncLogsTypeProps
  & SyncLogsExtraIdProps
  & {
  themed?: boolean
}

export const SyncLogsButton =
  ({type, themed, accountId, productId, orderId}: SyncLogsButtonProps) => {
    const api = useApi()

    const loadLogs =
      async () => {
        if (!productId && !orderId) {
          throw new Error('Either productId or orderId is required')
        }

        return await api.userSync.syncLogs({integration: type, accountId, productId, orderId})
      }

    return <SyncLogsButtonBase
      title={`${integrationTypeNames[type]} #${productId ?? orderId}`}
      icon={<SyncLogsIcon themed={themed} type={type}/>}
      loadLogs={loadLogs}
    />
  }

const SyncLogsIcon =
  ({themed}: Pick<SyncLogsButtonProps, 'themed' | 'type'>) =>
    <Info
      fontSize="small"
      color={themed ? undefined : 'action'}
      htmlColor={themed ? '#3987CF' : undefined}
    />